export const MIN_SLIDER_VALUE = 0
export const MAX_SLIDER_VALUE = 99
export const MAX_SLIDER_UI_STUB = 100
export const MIN_SWITCH_VALUE = 0
export const MAX_SWITCH_VALUE = 255
